import { useMutation, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { createFactureProduit, findAllAchats, findAllProduits } from "../services/produits.service";
import { AchatsResult, ProduitsResult } from "../interfaces/produits.interface";
import { ksAchatsQK, ksProduitsQK } from "../query-keys";

type QueryOptions<T> = Omit<UseQueryOptions<T>, "queryKey" | "queryFn">;

export const useProduits = (options?: QueryOptions<ProduitsResult>) =>
  useQuery({
    queryKey: [ksProduitsQK],
    queryFn: findAllProduits,
    ...options,
  });

export const useAchats = (options?: QueryOptions<AchatsResult>) =>
  useQuery({
    queryKey: [ksAchatsQK],
    queryFn: findAllAchats,
    ...options,
  });

export const useCreateFactureProduit = () =>
  useMutation({
    mutationFn: createFactureProduit,
  });
